import { render, staticRenderFns } from "./AccountingReport.vue?vue&type=template&id=5223678e&"
import script from "./AccountingReport.vue?vue&type=script&lang=js&"
export * from "./AccountingReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports